var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.5,
    height: 21.5,
    viewBox: "0 0 21.5 21.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard_icon",
    "data-name": "Dashboard icon",
    transform: "translate(-18.25 -212.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Style_Linear",
    "data-name": "Style=Linear",
    transform: "translate(-3 191)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_element-3",
    "data-name": "vuesax/linear/element-3",
    transform: "translate(22 22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "element-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M42,28.52V23.98c0-1.41-.64-1.98-2.23-1.98H35.73c-1.59,0-2.23.57-2.23,1.98v4.53c0,1.42.64,1.98,2.23,1.98h4.04C41.36,30.5,42,29.93,42,28.52Z",
    transform: "translate(-22 -22)",
    fill: "none",
    stroke: "#ff6a42",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M42,39.77V35.73c0-1.59-.64-2.23-2.23-2.23H35.73c-1.59,0-2.23.64-2.23,2.23v4.04c0,1.59.64,2.23,2.23,2.23h4.04C41.36,42,42,41.36,42,39.77Z",
    transform: "translate(-22 -22)",
    fill: "none",
    stroke: "#ff6a42",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M30.5,28.52V23.98c0-1.41-.64-1.98-2.23-1.98H24.23c-1.59,0-2.23.57-2.23,1.98v4.53c0,1.42.64,1.98,2.23,1.98h4.04C29.86,30.5,30.5,29.93,30.5,28.52Z",
    transform: "translate(-22 -22)",
    fill: "none",
    stroke: "#ff6a42",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M30.5,39.77V35.73c0-1.59-.64-2.23-2.23-2.23H24.23c-1.59,0-2.23.64-2.23,2.23v4.04c0,1.59.64,2.23,2.23,2.23h4.04C29.86,42,30.5,41.36,30.5,39.77Z",
    transform: "translate(-22 -22)",
    fill: "none",
    stroke: "#ff6a42",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIc);
export default __webpack_public_path__ + "static/media/dashboard-ic.df61525bab581e77e487cc20769207e6.svg";
export { ForwardRef as ReactComponent };